

import axios from "axios"
import { useEffect, useState } from "react";
import passTemplate from "./Candidates_VIP.jpeg";
import alumniTemplate from "./Alumni.jpeg";
import ssmTemplate from "./Social_Media_Member.png";

import QRCode from "qrcode";

import "./Pass.css"
import { Axios } from "../../Services/Axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const PLATFORM_NAMES = ["facebook", "youtube", "instagram", "tiktok"];

const Toast = ({ message, type, onClose }) => {
    if (!message) return null;

    return (
        <div className="toast-container">
            <div className={`toast ${type === "error" ? "toast-error" : "toast-success"}`}>
                <div className="toast-content">
                    <p>{message}</p>
                    <button onClick={onClose} className="toast-close">×</button>
                </div>
            </div>
        </div>
    );
};

export const Pass = () => {
    const [passes, setPasses] = useState([]);
    const [loading, setLoading] = useState(null);
    const [VisitorPassesCount, setVisitorPassesCount] = useState(0);
    const [jobFairCandidateCount, setJobFairCandidateCount] = useState(0);
    const [jobFairCompanyCount, setJobFairCompanyCount] = useState(0);
    const [VIPPassesCount, setVIPPassesCount] = useState(0);
    const [toast, setToast] = useState({ message: "", type: "" });
    const [allVipPasses, setAllVipPasses] = useState([]);
    const [allVisitorPasses, setAllVisitorPasses] = useState([]);
    const [allAlumniPasses, setAllAlumniPasses] = useState([]);
    const [allSsmPasses, setAllSsmPasses] = useState([]);
    const [AlumniPassesCount, setAlumniPassesCount] = useState(0);
    const [SsmPassesCount, setSsmPassesCount] = useState(0);
    const [exportLoading, setExportLoading] = useState(null); // 'vip' | 'visitor' | 'alumni' | 'ssm' | null
    const [activeTab, setActiveTab] = useState("pending"); // 'pending' | 'approved' | 'visitors' | 'alumni-pending' | 'alumni-approved'
    const [searchQuery, setSearchQuery] = useState("");
    const BASE_URL = "https://webbackend.aptech-education.com.pk";
    // const BASE_URL_TEMP = "https://aptech-education.innovadorhub.com";



    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(" ");
        let line = "";
        for (let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + " ";
            const metrics = ctx.measureText(testLine);
            if (metrics.width > maxWidth && n > 0) {
                ctx.fillText(line, x, y);
                line = words[n] + " ";
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
        return y + lineHeight;
    }

    const showToast = (message, type = "success") => {
        setToast({ message, type });
        setTimeout(() => setToast({ message: "", type: "" }), 3000);
    };

    const getImage = async (url) => {
        try {
            const response = await axios.post(
                `${'https://webbackend.aptech-education.com.pk'}/api/ConversationAttachment/GetFileUrl?url=${url}`,
                {},
                { responseType: "arraybuffer" }
            );
            const blob = new Blob([response.data], { type: "image/png" });
            return URL.createObjectURL(blob);
        } catch (err) {
            console.error("Error fetching image:", err);
            return null;
        }
    };


    const handleApprove = async (passData) => {
        setLoading(passData.id);
        const { id, firstName, lastName, email, phone, organization, designation, profileImage, attendeeType, platformlinks } = passData;
        const isAlumni = attendeeType === "ALUMNI";
        const isSsm = attendeeType === "SMM";
        const delegateLabel = isAlumni ? "Alumni Awards Nominee" : isSsm ? "Social Media Member" : "VIP Delegate";
        const guestLabel = isAlumni ? "Alumni" : isSsm ? "Social Media Member" : "VIP";
        const templateImg = isAlumni ? alumniTemplate : isSsm ? ssmTemplate : passTemplate;

        await new Promise(async (resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.src = templateImg;

            img.onload = async () => {
                const canvas = document.createElement("canvas");
                const scale = 2;
                canvas.width = 420 * scale;
                canvas.height = 686 * scale;
                const ctx = canvas.getContext("2d");

                if (!ctx) {
                    reject(new Error("Failed to get canvas context"));
                    return;
                }

                ctx.drawImage(img, 0, 0, 420 * scale, 686 * scale);

                // ✅ Profile Image
                if (profileImage) {
                    try {
                        const profileUrl = await getImage(profileImage);
                        if (profileUrl) {
                            await new Promise((res, rej) => {
                                const profileImg = new Image();
                                profileImg.crossOrigin = "anonymous";
                                profileImg.src = profileUrl;

                                profileImg.onload = () => {
                                    const profileSize = isSsm ? 240 : 200;
                                    const profileX = 420 - profileSize / 2;
                                    const profileY = 463 - profileSize / 2;

                                    ctx.save();
                                    ctx.beginPath();
                                    ctx.arc(
                                        profileX + profileSize / 2,
                                        profileY + profileSize / 2,
                                        profileSize / 2,
                                        0,
                                        Math.PI * 2,
                                        true
                                    );
                                    ctx.closePath();
                                    ctx.clip();

                                    ctx.drawImage(profileImg, profileX, profileY, profileSize, profileSize);
                                    ctx.restore();
                                    res(true);
                                };

                                profileImg.onerror = rej;
                            });
                        }
                    } catch (err) {
                        console.error("Error loading profile image:", err);
                    }
                }

                // ✅ Add Text
                ctx.fillStyle = isAlumni || isSsm ? "#000" : "#fff";
                ctx.textAlign = "center";
                const centerX = 415;
                let yPos = isSsm ? 645 : 600;

                ctx.font = isSsm ? "bold 40px Helvetica" : "bold 28px Helvetica";
                ctx.fillText(`${firstName} ${lastName}`, centerX, yPos);
                yPos += isSsm ? 60 : 40;

                if (!isSsm) {
                    yPos = wrapText(ctx, `Organization: ${organization}`, centerX, yPos, 650, 40);
                    yPos = wrapText(ctx, `Designation: ${designation}`, centerX, yPos, 650, 40);
                } else {
                    // SMM: draw platform usernames
                    ctx.font = "bold 26px Helvetica";
                    (platformlinks || [])
                        .filter((p) => p?.link && String(p.link).trim())
                        .forEach((p) => {
                            ctx.fillText(`${p.platformName}: ${p.link}`, centerX, yPos);
                            yPos += 42;
                        });
                }

                // ✅ QR Code
                const qrDataUrl = await QRCode.toDataURL(id.toString(), {
                    width: 100,
                    margin: 1,
                });

                const qrImg = new Image();
                qrImg.src = qrDataUrl;

                qrImg.onload = () => {
                    // ctx.drawImage(qrImg, 320, 790, 200, 200);

                    canvas.toBlob(async (blob) => {
                        if (!blob) {
                            reject(new Error("Failed to create blob"));
                            return;
                        }

                        const file = new File([blob], "aptech-vision-pass.png", {
                            type: "image/png",
                        });

                        // ✅ Send Email
                        const emailForm = new FormData();
                        emailForm.append("Email", email);
                        emailForm.append("Subject", `Confirmation as ${delegateLabel} – Aptech Vision 2026 🚀`);
                        emailForm.append(
                            "Body",
                            isAlumni
                                ? `<p>Dear ${firstName} ${lastName},</p>

  <p>We are honored to welcome you as an <strong>Alumni Awards Nominee</strong> for 
  <strong>Aptech Vision 2026</strong>, taking place on 
  <strong>Saturday, 22 August 2026</strong> at 
  <strong>PC Hotel, Karachi</strong>.</p>

  <p>
    📅 <strong>Date:</strong> Saturday, 22 August 2026<br>
    🕚 <strong>Time:</strong> 10:00 AM onwards<br>
    📍 <strong>Venue:</strong> Zavar Hall, Pearl Continental Hotel, Karachi
  </p>

  <p><strong>Note:</strong> Your attached Alumni Awards Pass is issued exclusively in your name and is non-transferable. Please do not share this pass with anyone else, as it is valid for your entry only. The QR code on the pass will be scanned at the registration desk for entry. Kindly bring a valid ID (such as CNIC or Company ID card) for cross-verification to ensure a smooth check-in process.</p>

  <p>We look forward to celebrating your achievements and hosting you at <strong>Aptech Vision 2026</strong> for an inspiring and memorable experience! 🚀</p>

  <p>Best Regards,<br>
  <strong>Aptech Pakistan Team</strong></p>`
                                : isSsm
                                    ? `<p><strong>🎉 APTECH SOCIAL MEDIA CLUB – CONFIRMED! 🎉</strong></p>

  <p>Congratulations! You have been officially confirmed to cover <strong>Aptech Vision 2026</strong> — hosted by <strong>Aptech Learning Pakistan</strong>.</p>

  <p>
    📅 <strong>Date:</strong> 22nd August 2026<br>
    📍 <strong>Venue:</strong> Zaver Hall, Pearl-Continental Hotel, Karachi<br>
    ⏰ <strong>Reporting Time:</strong> 9:30 AM Sharp
  </p>

  <p><strong>🎒 What to Bring:</strong><br>
  Bring your own equipment — camera/phone, microphone, gimbal, power bank, memory card, charger, etc. Also bring your valid Aptech Social Creator Pass, required for entry.</p>

  <p><strong>⚠️ Guidelines You Must Follow:</strong></p>
  <ul>
    <li>Professional conduct and full compliance with Aptech Vision rules is mandatory</li>
    <li>Punctuality is mandatory</li>
    <li>Aptech is not responsible for any loss or damage to your equipment</li>
    <li>Minimum 45 seconds of professional-quality content</li>
    <li>You may cover one or multiple parts of the event, but only one video per person will be evaluated</li>
    <li>Tag @Aptech across all platforms (Facebook, Instagram, LinkedIn, TikTok, YouTube)</li>
  </ul>

  <p><strong>⏳ Deadlines:</strong></p>
  <ul>
    <li>Content Upload: 24th August 2026</li>
    <li>Final Submission: 31st August 2026</li>
  </ul>

  <p>By participating, you agree to follow all Terms &amp; Conditions set for the Aptech Social Media Club.</p>

  <p>See you on 22nd August — time to show off your creativity! 🚀</p>

  <p>Regards,<br>
  <strong>Aptech Learning Pakistan</strong></p>`
                                    : `<p>Dear ${firstName} ${lastName},</p>

  <p>We are honored to welcome you as a <strong>${delegateLabel}</strong> for 
  <strong>Aptech Vision 2026</strong>, taking place on 
  <strong>Saturday, 22 August 2026</strong> at 
  <strong>PC Hotel, Karachi</strong>.</p>

  <p>As our esteemed ${guestLabel} guest, you are also invited to attend the Conference on 
  <em>“Tech Dialogue Pakistan”</em>.</p>

  <p>
    📅 <strong>Date:</strong> Saturday, 22 August 2026<br>
    🕚 <strong>Time:</strong> 10:00 AM onwards<br>
    📍 <strong>Venue:</strong> Pearl Continental Hotel, Karachi
  </p>

  <p><strong>Note:</strong> Your attached ${delegateLabel} Pass is issued exclusively in your name and is non-transferable. The QR code on the pass will be scanned at the registration desk for entry. Kindly bring a valid ID (such as CNIC or Company ID card) for cross-verification to ensure a smooth check-in process.</p>

  <p>We look forward to hosting you at <strong>Aptech Vision 2026</strong> for an inspiring and memorable experience! 🚀</p>

  <p>Best Regards,<br>
  <strong>Aptech Pakistan Team</strong></p>`
                        );

                        emailForm.append("Pass", file);

                        await fetch(`${BASE_URL}/api/Attendee/SendEmail`, {
                            method: "POST",
                            body: emailForm,
                        });


                        // ✅ Update Status formData
                        const statusForm = new FormData();
                        statusForm.append("Id", id);
                        //do for all
                        statusForm.append("FirstName", firstName);
                        statusForm.append("LastName", lastName);
                        statusForm.append("Email", email);
                        statusForm.append("Phone", phone);
                        statusForm.append("Organization", organization);
                        statusForm.append("Designation", designation);
                        if (profileImage) {
                            statusForm.append("ProfileImage", profileImage);
                        }
                        statusForm.append("AttendeeType", attendeeType || "VIP");
                        statusForm.append("Status", "3"); // Approved

                        // Preserve SMM platform usernames on update
                        if (Array.isArray(platformlinks)) {
                            platformlinks.forEach((p, i) => {
                                statusForm.append(`Platformlinks[${i}].PlatformName`, p?.platformName || "");
                                statusForm.append(`Platformlinks[${i}].Link`, p?.link || "");
                            });
                        }

                        await fetch(`${BASE_URL}/api/Attendee/Update`, {
                            method: "PUT",
                            body: statusForm,
                        });






                        // Refresh passes
                        fetchPasses();


                        // // ✅ Download locally
                        // const a = document.createElement("a");
                        // a.href = URL.createObjectURL(file);
                        // a.download = "aptech-vision-pass.png";
                        // document.body.appendChild(a);
                        // a.click();
                        // document.body.removeChild(a);
                        setLoading(null);
                        showToast("Pass approved and email sent!");
                        resolve(true);
                    }, "image/png");
                };
            };

            img.onerror = reject;
        });
    };


    useEffect(() => {
        fetchPasses();
        fetchJobFairCounts();
    }, []);

    const fetchPasses = () => {
        axios
            .get(`${BASE_URL}/api/Attendee/GetAll`)
            .then((res) => {
                const allData = res.data || [];

                // Split by attendeeType
                let vipData = allData.filter((e) => e.attendeeType === "VIP");
                let visitorData = allData.filter((e) => e.attendeeType === "VISITOR");
                let alumniData = allData.filter((e) => e.attendeeType === "ALUMNI");
                let ssmData = allData.filter((e) => e.attendeeType === "SMM");

                // All types: unique by email only (normalized)
                const emailKey = (item) =>
                    (item.email || "").trim().toLowerCase();

                const uniqueBy = (data, keyFn) => [
                    ...new Map(data.map(item => [keyFn(item), item])).values()
                ];

                vipData = uniqueBy(vipData, emailKey);
                visitorData = uniqueBy(visitorData, emailKey);
                alumniData = uniqueBy(alumniData, emailKey);
                ssmData = uniqueBy(ssmData, emailKey);

                // Sort: most recent createdDate first
                const sortByDate = (data) =>
                    [...data].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

                // Normalize null status to 0 (pending) so SMM behaves like VIP
                const normalizeStatus = (data) =>
                    data.map((item) => ({
                        ...item,
                        status: item?.status == null ? 0 : item.status,
                    }));

                vipData = normalizeStatus(sortByDate(vipData));
                visitorData = normalizeStatus(sortByDate(visitorData));
                alumniData = normalizeStatus(sortByDate(alumniData));
                ssmData = normalizeStatus(sortByDate(ssmData));

                // Store all deduplicated data for CSV export
                setAllVipPasses(vipData);
                setAllVisitorPasses(visitorData);
                setAllAlumniPasses(alumniData);
                setAllSsmPasses(ssmData);

                // Pending VIPs (status !== 3) for the approval list
                const pendingVip = vipData.filter((e) => e.status !== 3);
                setPasses(pendingVip);

                // Counts
                setVIPPassesCount(vipData.filter((e) => e.status === 3).length);
                setVisitorPassesCount(visitorData.length);
                setAlumniPassesCount(alumniData.filter((e) => e.status === 3).length);
                setSsmPassesCount(ssmData.filter((e) => e.status === 3).length);
            })
            .catch((err) => console.log(err));
    };

    const fetchJobFairCounts = () => {
        axios
            .get("https://api.jobgenie.solutions/api/AptechVision/GetDistinctCountOfPassGeneratedCandidatesAndCompanies")
            .then((res) => {
                setJobFairCandidateCount(res.data?.candidateCount ?? 0);
                setJobFairCompanyCount(res.data?.companyCount ?? 0);
            })
            .catch((err) => console.log(err));
    };



    // --- Computed / Filtered Data ---
    const pendingVip = allVipPasses.filter(e => e.status !== 3);
    const approvedVip = allVipPasses.filter(e => e.status === 3);
    const pendingAlumni = allAlumniPasses.filter(e => e.status !== 3);
    const approvedAlumni = allAlumniPasses.filter(e => e.status === 3);
    const pendingSsm = allSsmPasses.filter(e => e.status !== 3);
    const approvedSsm = allSsmPasses.filter(e => e.status === 3);

    const filterBySearch = (data) => {
        if (!searchQuery.trim()) return data;
        const q = searchQuery.toLowerCase();
        return data.filter(e =>
            `${e.firstName} ${e.lastName}`.toLowerCase().includes(q) ||
            e.email?.toLowerCase().includes(q) ||
            e.phone?.includes(q) ||
            e.organization?.toLowerCase().includes(q) ||
            e.designation?.toLowerCase().includes(q) ||
            e.university?.toLowerCase().includes(q) ||
            e.studentId?.toLowerCase().includes(q) ||
            e.centreName?.toLowerCase().includes(q)
        );
    };

    const getPlatformLinks = (pass) =>
        PLATFORM_NAMES.map((name) => {
            const found = (pass?.platformlinks || []).find(
                (p) => p?.platformName?.toLowerCase() === name
            );
            return { platformName: name, link: found?.link || "" };
        });

    const displayedPasses = filterBySearch(
        activeTab === "pending"        ? pendingVip :
        activeTab === "approved"       ? approvedVip :
        activeTab === "alumni-pending"  ? pendingAlumni :
        activeTab === "alumni-approved" ? approvedAlumni :
        activeTab === "ssm-pending"     ? pendingSsm :
        activeTab === "ssm-approved"    ? approvedSsm :
        allVisitorPasses
    );

    const tabLabel =
        activeTab === "pending"         ? "VIP Delegate Pending" :
        activeTab === "approved"        ? "VIP Delegate Approved" :
        activeTab === "alumni-pending"  ? "Alumni Pending" :
        activeTab === "alumni-approved" ? "Alumni Approved" :
        activeTab === "ssm-pending"     ? "SSM Pending" :
        activeTab === "ssm-approved"    ? "SSM Approved" :
        "Visitors";

    const activeCount =
        activeTab === "pending"         ? pendingVip.length :
        activeTab === "approved"        ? approvedVip.length :
        activeTab === "alumni-pending"  ? pendingAlumni.length :
        activeTab === "alumni-approved" ? approvedAlumni.length :
        activeTab === "ssm-pending"     ? pendingSsm.length :
        activeTab === "ssm-approved"    ? approvedSsm.length :
        allVisitorPasses.length;


    const exportByType = (data, filename, type) => {
        try {
            setExportLoading(type);
            const workbook = XLSX.utils.book_new();
            const exportData = type === "ssm"
                ? data.map((item) => {
                    const { platformlinks, ...rest } = item || {};
                    const links = {};
                    getPlatformLinks(item).forEach((p) => {
                        links[p.platformName] = p.link;
                    });
                    return { ...rest, ...links };
                })
                : data;
            const sheet = XLSX.utils.json_to_sheet(exportData);
            const sheetName = type === "vip" ? "VIPs" : type === "alumni" ? "Alumni" : type === "ssm" ? "SSM" : "Visitors";
            XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
            const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
            showToast(`${type === "vip" ? "VIP" : type === "alumni" ? "ALUMNI" : type === "ssm" ? "SSM" : "VISITOR"} data exported successfully!`);
        } catch (err) {
            console.error("Error exporting data:", err);
            showToast("Error exporting data", "error");
        } finally {
            setExportLoading(null);
        }
    };

    const exportVIP = () => exportByType(allVipPasses, "VIP_Passes.xlsx", "vip");
    const exportVisitor = () => exportByType(allVisitorPasses, "Visitor_Passes.xlsx", "visitor");
    const exportAlumni = () => exportByType(allAlumniPasses, "Alumni_Passes.xlsx", "alumni");
    const exportSsm = () => exportByType(allSsmPasses, "SSM_Passes.xlsx", "ssm");


    return (
        <div className="app">
            <div className="container">
                {/* Header */}
                <header className="header">
                    <h1>E-Pass Management</h1>
                    <p>Aptech Vision 2026 — VIP Delegate, Alumni, SSM & Visitor Pass Administration</p>
                    <div className="header-actions">
                        <button
                            onClick={exportVIP}
                            disabled={exportLoading === "vip"}
                            className="btn-export btn-vip"
                        >
                            {exportLoading === "vip" ? "Exporting..." : `Export VIPs (${allVipPasses.length})`}
                        </button>
                        <button
                            onClick={exportAlumni}
                            disabled={exportLoading === "alumni"}
                            className="btn-export btn-alumni"
                        >
                            {exportLoading === "alumni" ? "Exporting..." : `Export Alumni (${allAlumniPasses.length})`}
                        </button>
                        <button
                            onClick={exportSsm}
                            disabled={exportLoading === "ssm"}
                            className="btn-export btn-ssm"
                        >
                            {exportLoading === "ssm" ? "Exporting..." : `Export SSM (${allSsmPasses.length})`}
                        </button>
                        <button
                            onClick={exportVisitor}
                            disabled={exportLoading === "visitor"}
                            className="btn-export btn-visitor"
                        >
                            {exportLoading === "visitor" ? "Exporting..." : `Export Visitors (${allVisitorPasses.length})`}
                        </button>
                    </div>
                </header>

                {/* Stats */}
                <div className="stats">
                    <div className="stat-card">
                        <div className="stat-icon icon-pending">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>VIP Delegate Pending</p>
                            <h2>{pendingVip.length}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-approved">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>VIP Delegate Approved</p>
                            <h2>{VIPPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-pending">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>Alumni Pending</p>
                            <h2>{pendingAlumni.length}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-approved">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>Alumni Approved</p>
                            <h2>{AlumniPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-pending">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>SSM Pending</p>
                            <h2>{pendingSsm.length}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-approved">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>SSM Approved</p>
                            <h2>{SsmPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-visitor">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>Visitors</p>
                            <h2>{VisitorPassesCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-jobfair-candidate">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6d28d9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>Job Fair Candidates</p>
                            <h2>{jobFairCandidateCount}</h2>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon icon-jobfair-company">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6d28d9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><path d="M12 12v.01"/><path d="M8 12v.01"/><path d="M16 12v.01"/></svg>
                        </div>
                        <div className="stat-info">
                            <p>Job Fair Companies</p>
                            <h2>{jobFairCompanyCount}</h2>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="tabs">
                    <button
                        className={`tab ${activeTab === "pending" ? "active" : ""}`}
                        onClick={() => setActiveTab("pending")}
                    >
                        VIP Pending <span className="badge">{pendingVip.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "approved" ? "active" : ""}`}
                        onClick={() => setActiveTab("approved")}
                    >
                        VIP Approved <span className="badge">{approvedVip.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "alumni-pending" ? "active" : ""}`}
                        onClick={() => setActiveTab("alumni-pending")}
                    >
                        Alumni Pending <span className="badge">{pendingAlumni.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "alumni-approved" ? "active" : ""}`}
                        onClick={() => setActiveTab("alumni-approved")}
                    >
                        Alumni Approved <span className="badge">{approvedAlumni.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "ssm-pending" ? "active" : ""}`}
                        onClick={() => setActiveTab("ssm-pending")}
                    >
                        SSM Pending <span className="badge">{pendingSsm.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "ssm-approved" ? "active" : ""}`}
                        onClick={() => setActiveTab("ssm-approved")}
                    >
                        SSM Approved <span className="badge">{approvedSsm.length}</span>
                    </button>
                    <button
                        className={`tab ${activeTab === "visitors" ? "active" : ""}`}
                        onClick={() => setActiveTab("visitors")}
                    >
                        Visitors <span className="badge">{allVisitorPasses.length}</span>
                    </button>
                </div>

                {/* Search */}
                <div className="search-bar">
                    <span className="search-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    </span>
                    <input
                        type="text"
                        placeholder="Search by name, email, phone, organization, university, student ID..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* Section */}
                <section>
                    <div className="section-header">
                        <h2>{tabLabel} Requests</h2>
                        <span className="result-count">
                            {searchQuery.trim()
                                ? `${displayedPasses.length} of ${activeCount} results`
                                : `${displayedPasses.length} total`}
                        </span>
                    </div>

                    {displayedPasses.length === 0 ? (
                        <div className="empty-state">
                            <div className="empty-icon">
                                {searchQuery.trim() ? (
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                                ) : (
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                                )}
                            </div>
                            <h3>
                                {searchQuery.trim()
                                    ? "No matching results found"
                                    : activeTab === "pending"
                                        ? "No pending VIP pass requests"
                                        : activeTab === "approved"
                                            ? "No approved VIP passes yet"
                                            : activeTab === "alumni-pending"
                                                ? "No pending Alumni pass requests"
                                                : activeTab === "alumni-approved"
                                                    ? "No approved Alumni passes yet"
                                                : activeTab === "ssm-pending"
                                                    ? "No pending SSM pass requests"
                                                    : activeTab === "ssm-approved"
                                                        ? "No approved SSM passes yet"
                                                        : "No visitor passes yet"}
                            </h3>
                            <p>
                                {searchQuery.trim()
                                    ? "Try adjusting your search query"
                                    : activeTab === "pending"
                                        ? "Pending VIP requests will appear here for approval"
                                        : activeTab === "alumni-pending"
                                            ? "Pending Alumni requests will appear here for approval"
                                            : activeTab === "ssm-pending"
                                                ? "Pending SSM requests will appear here for approval"
                                                : "Check back later for new entries"}
                            </p>
                        </div>
                    ) : (
                        <div className="pass-list">
                            {displayedPasses.map((pass) => (
                                <div key={pass.id} className="pass-card">
                                    <div className="pass-card-top">
                                        <div className="pass-header">
                                            <img src={`${'https://webbackend.aptech-education.com.pk'}/${pass?.profileImage}`} alt="" />
                                            <div>
                                                <h3>{pass?.firstName + " " + pass?.lastName}</h3>
                                                {pass?.attendeeType === "VISITOR" && pass?.studentType === "Outsider" && (
                                                    <p>{pass?.university || "—"}</p>
                                                )}
                                                {pass?.attendeeType === "VISITOR" && pass?.studentType === "Aptech Student" && (
                                                    <p>{pass?.studentId || "—"}{pass?.centreName ? ` — ${pass.centreName}` : ""}</p>
                                                )}
                                                {pass?.attendeeType === "VISITOR" && !pass?.studentType && (
                                                    <p>{pass.designation}{pass.organization ? ` — ${pass.organization}` : ""}</p>
                                                )}
                                                {(pass?.attendeeType === "VIP" || pass?.attendeeType === "ALUMNI" || pass?.attendeeType === "SMM") && (
                                                    <p>
                                                        {pass?.attendeeType === "SMM"
                                                            ? (getPlatformLinks(pass).filter((p) => p.link).map((p) => p.platformName).join(" · ") || "Social Media Member")
                                                            : `${pass.designation}${pass.organization ? ` — ${pass.organization}` : ""}`}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        {(pass?.attendeeType === "VIP" || pass?.attendeeType === "ALUMNI" || pass?.attendeeType === "SMM") && (
                                            <span className={`status ${pass?.status === 3 ? "approved" : "pending"}`}>
                                                {pass?.status === 3 ? "Approved" : "Pending"}
                                            </span>
                                        )}
                                        {pass?.attendeeType === "VISITOR" && (
                                            <span className="status visitor">Visitor</span>
                                        )}
                                    </div>

                                    <div className="pass-body">
                                        <div>
                                            <p className="label">Email</p>
                                            <p>{pass?.email}</p>
                                        </div>
                                        <div>
                                            <p className="label">Phone</p>
                                            <p>{pass?.phone}</p>
                                            <div className="contact-links">
                                                {/* <a href={`tel:${pass?.phone}`} className="contact-link">Call</a> */}
                                            </div>
                                        </div>
                                        <div>
                                            <p className="label">Request Date</p>
                                            <p>{pass?.createdDate?.split("T")[0]}</p>
                                        </div>
                                        {(pass?.attendeeType === "VIP" || pass?.attendeeType === "ALUMNI") && (
                                            <div>
                                                <p className="label">Organization</p>
                                                <p>{pass?.organization || "—"}</p>
                                            </div>
                                        )}
                                        {pass?.attendeeType === "SMM" && (
                                            <div>
                                                <p className="label">Platform Usernames</p>
                                                {getPlatformLinks(pass).filter((p) => p.link).length > 0
                                                    ? getPlatformLinks(pass).filter((p) => p.link).map((p) => (
                                                        <p key={p.platformName}>
                                                            <span className="platform-username">{p.platformName}: {p.link}</span>
                                                        </p>
                                                    ))
                                                    : <p>—</p>}
                                            </div>
                                        )}
                                        {pass?.attendeeType === "VISITOR" && pass?.studentType === "Outsider" && (
                                            <div>
                                                <p className="label">University</p>
                                                <p>{pass?.university || "—"}</p>
                                            </div>
                                        )}
                                        {pass?.attendeeType === "VISITOR" && pass?.studentType === "Aptech Student" && (
                                            <>
                                                <div>
                                                    <p className="label">Student ID</p>
                                                    <p>{pass?.studentId || "—"}</p>
                                                </div>
                                                <div>
                                                    <p className="label">Centre Name</p>
                                                    <p>{pass?.centreName || "—"}</p>
                                                </div>
                                            </>
                                        )}
                                        {pass?.attendeeType === "VISITOR" && !pass?.studentType && (
                                            <div>
                                                <p className="label">Organization</p>
                                                <p>{pass?.organization || "—"}</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="actions">
                                        {(pass?.attendeeType === "VIP" || pass?.attendeeType === "ALUMNI" || pass?.attendeeType === "SMM") && pass?.status !== 3 && (
                                            <button
                                                onClick={() => handleApprove(pass)}
                                                disabled={loading === pass.id}
                                                className="btn btn-approve"
                                            >
                                                {loading === pass.id ? "Approving..." : "Approve Pass"}
                                            </button>
                                        )}

                                        {pass?.status === 3 && (pass?.attendeeType === "VIP" || pass?.attendeeType === "ALUMNI" || pass?.attendeeType === "SMM") && (
                                            <button onClick={() => handleApprove(pass)} className="btn btn-resend">
                                                Resend {pass?.attendeeType === "ALUMNI" ? "Alumni" : pass?.attendeeType === "SMM" ? "SSM" : "VIP"} e-Pass
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </section>
            </div>
            <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: "", type: "" })} />
        </div>
    );;
}
